import { COLORS, hexToRGB } from '@shared/config/colors/colors';
import { baseShadowStyle } from '@shared/style/base-shadow';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    padding: 16px 20px;
    gap: 8px;
    background: ${COLORS.neutral_00};
    border-radius: 20px;
    ${baseShadowStyle}
`;

export const Title = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const CellsWrapper = styled('div')`
    display: flex;
    gap: 24px;
`;

export const DocumentName = styled('div')`
    display: flex;
    gap: 10px;
    align-items: center;
    color: ${COLORS.neutral_90};
`;

export const Controls = styled('div')`
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const Cell = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
    word-break: break-all;
`;

export const CodeCell = styled(Cell)`
    width: 186px;
`;

export const PathCell = styled(Cell)`
    width: 314px;
`;

export const ImageWrapper = styled('div')`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        opacity: 0;
        transition: 0.3s;
        background-color: ${hexToRGB(COLORS.black, 0.4)};
    }

    & svg {
        opacity: 0;
        transition: 0.3s;
        z-index: 1;
    }

    &:hover {
        &::after {
            opacity: 1;
        }
        & svg {
            opacity: 1;
        }
    }
`;

export const Image = styled('img')`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;
